<template>
    <div class="text-center">
        <v-card class="text-center">
            <div class="d-flex justify-space-between mb-5" id="modal-header">
                <v-card-title class="py-3">Test Ortamına Dosya Yükle</v-card-title>
            </div>
            <v-card-subtitle>
                Lütfen 1 adet dosya seçip yükleyiniz..
            </v-card-subtitle>
            <v-container class="d-flex">
                <v-col>
                    <v-card-text>
                        <div v-if="!uploading" class="text-center">
                            <div>
                                <v-btn icon class="grey lighten-2 mb-4" style="height: 98px;width: 98px;"
                                    @click="selectFile">
                                    <v-icon x-large class="grey--text text--darken-1">mdi-upload</v-icon>
                                </v-btn>
                            </div>
                            <ValidationProvider rules="required|size:1200000" v-slot="{ errors }" name="file"
                                ref="provider">
                                <v-file-input @change="uploadFile" v-model="selectedFile"
                                    placeholder="Dosya seçmek için tıklayınız.." prepend-icon="mdi-file"
                                    :error-messages="errors" ref="fileInput">
                                </v-file-input>
                            </ValidationProvider>
                        </div>
                        <v-progress-circular v-else :rotate="360" :size="100" :width="15" :value="value" color="teal">
                            {{ value }}
                        </v-progress-circular>
                    </v-card-text>
                </v-col>
            </v-container>
        </v-card>
        <v-snackbar v-model="snackbar">
            {{ snackbarDesc }}
            <v-btn color="white" text @click="snackbar = false" icon>
                <v-icon>mdi-close-circle</v-icon>
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
import FileService from "@/services/FileService";

export default {
    name: "UploadFile",
    data: function () {
        return {

            snackbarDesc: '',
            snackbar: false,

            valid: false,
            uploaded: false,
            uploading: false,


            value: 0,
            errors: [],
            rules: [
                (value) =>
                    !value ||
                    value.size > 1200000000 ||
                    `Video boyutu en fazla 1000 MB olabilir!, ${value.size}`,
            ],
            selectedFile: null,
            headers: { Authorization: `Bearer ${this.$store.getters.getToken}` },
        };
    },
    methods: {

        showSnackbar(desc) {
            this.snackbarDesc = desc
            this.snackbar = true
        },

        async uploadFile(e) {

            const { valid } = await this.$refs.provider.validate(e);

            if (!valid) return;

            this.uploading = true;
            const fd = new FormData();
            fd.append("file", this.selectedFile, this.selectedFile.name);

            let response = await FileService.uploadTestFile(fd, {
                onUploadProgress: (uploadEvent) => {
                    this.value = Math.round(
                        (uploadEvent.loaded / uploadEvent.total) * 100
                    );
                },
            })
                .catch((err) => {
                    this.showSnackbar(err)
                })
                .finally(() => {
                    this.uploaded = true;
                    this.uploading = false;
                    this.selectedFile = null;
                });

            if (!response || !response.data || !response.data.data) {
                this.showSnackbar('Document yükleme sırasında bilinmeyen bir hata oluştu,  konsolu kontrol edebilirsiniz')
                return;
            }

            if (response.data.data.error) {
                this.showSnackbar(response.data.data.errorDescription)
                return;
            }

            if (response.data.success == true) {
                this.showSnackbar(response.data.data.filePathName + ' adlı dosya başarıyla yüklendi.')
            }

        },
        selectFile() {
            this.$refs.fileInput.$refs.input.click();
        },
    },

};
</script>

<style lang="scss">
#modal-header {
    border-bottom: 1px solid rgb(238, 232, 232);
}

#image-placeholder {
    padding-top: 8em;
    padding-bottom: 8em;
    border: 2px dashed rgb(209, 209, 209);
}
</style>
